import * as React from "react";
import "./ProductsBlock.css";

import actuatorImgWebp from "../../media/products/a-series-actuator.webp";
import actuatorImgPng from "../../media/products/a-series-actuator.png";
import encoder5047Img from "../../media/products/5047.png";
import encoder730Img from "../../media/products/730.png"
import downloadIcon from "../../media/icons/download.svg";
import buyIcon from "../../media/icons/buy.svg";
import mailIcon from "../../media/icons/mail.svg";
import nMotionLogo from "../../media/nmotion-logo.svg";
// import customActuatorImg from "../../media/custom-actuators.png";
import prod1ImgPng from "../../media/production-1.png";
import prod2ImgPng from "../../media/production-2.png";
import prod3ImgPng from "../../media/production-3.png";
import prod1ImgWebp from "../../media/production-1.webp";
import prod2ImgWebp from "../../media/production-2.webp";
import prod3ImgWebp from "../../media/production-3.webp";

import {
  actuatorBrochureLink,
  enc5047AmazonLink,
  encoder5047Datasheet,
  enc730AmazonLink,
  encoder730Datasheet,
  rfqFormLink,
} from "../../config/links";
import { OutboundLink } from "gatsby-plugin-google-gtag";

class ProductsBlock extends React.Component {
  render() {
    return (
      <div id="products">
        <div class="text-center text-2xl md:text-4xl font-medium">
          <h1>Our Products</h1>
        </div>
        <div id="nmotion-logo" className="p-2 sm:p-6">
          <img className="mx-auto h-12 sm:h-16" src={nMotionLogo} />
         </div>
        <div
          id="actuators"
          class="max-w-screen-xl m-auto text-center relative mb-2"
        >
          <div class="m-2">
            <div class="text-xl md:text-3xl m-2">
              <h1>A-Series Actuators</h1>
            </div>
            <div class="text-sm md:text-2xl">
              High Torque Density Solid Shaft Actuators
            </div>
          </div>
          <div class="product-img transfrom-none">
            <picture class="flex flex-col m-auto h-56 sm:h-96">
              <source srcset={actuatorImgWebp} type="image/webp" />
              <source srcset={actuatorImgPng} type="image/png" />
              <img
                src={actuatorImgPng}
                className="object-contain min-h-0 w-full"
                alt="actuator-image"
              />
            </picture>
          </div>
          <div class="product-motto text-xl md:text-3xl m-4">
            <h2>Lightweight and Powerful</h2>
          </div>
          <div class="text-lg md:text-2xl px-2">
            <h2>
              Solid Shaft Actuators with High Performance Brushless DC Motors
              and Harmonic Gears
            </h2>
          </div>
          <div
            class="
              flex flex-row
              text-lg
              md:text-2xl
              px-2
              justify-center
              flex-wrap
            "
          >
            <div class="mx-3">
              <h3>Torques upto 140 Nm</h3>
            </div>
            <div class="mx-3">
              <h3>Weighs under 2 kg</h3>
            </div>
            <div class="mx-3">
              <h3>Speeds upto 60 RPM</h3>
            </div>
            <div class="mx-3">
              <h3>Built-in Encoder with resolution upto 14 bits</h3>
            </div>
          </div>
          <div class="text-lg md:text-2xl p-2">
            <h2>For more details please checkout the product brochure</h2>
          </div>
          <div className="dont-highlight-on-touch flex flex-col sm:flex-row justify-center items-center text-lg md:text-xl">
            <OutboundLink
              href={rfqFormLink}
              target="_blank"
              className="rfq-btn rfq-btn-gtag p-4 w-56 sm:mx-4 my-2 md:my-6 md:w-64 h-10 md:h-16 flex flex-row items-center justify-center "
            >
              Request for Quotation
            </OutboundLink>
            <OutboundLink
              href={actuatorBrochureLink}
              target="_blank"
              className="brochure-btn brochure-btn-gtag  p-4 sm:mx-4 my-2 md:my-6 w-60 flex flex-row items-center justify-center h-10 md:h-16 m-2"
              aria-label="Get Brochure"
            >
              <div className="inline-block mr-2 brochure-btn-gtag">
                <img
                  src={downloadIcon}
                  className="h-6 brochure-btn-gtag"
                  alt="download"
                />
              </div>
              <div className="inline-block brochure-btn-gtag">
                Download Brochure
              </div>
            </OutboundLink>
          </div>
        </div>
        <div id="customisation" className="w-full">
          <div
            id="customisation"
            className="max-w-screen-xl text-white m-auto text-center pb-6 pt-1"
          >
            <div className="text-center text-xl md:text-3xl my-2 mx-2 mt-4">
              Customisation and Actuator Development
            </div>
            <div class="text-lg md:text-2xl mb-4 text-center mx-2">
              <h1>
                We can also provide custom actuators based on your requirements
                such as Load and Speed, Hollow Shaft, Encoder and Sensor
                Integration, Weight and size optimisation and Compatible
                Fixtures and Couplings{" "}
              </h1>
            </div>
            <div class="flex-col sm:flex-row m-auto items-center justify-center hidden xsm:flex">
              <div className="px-1 pt-1 ">
                <picture>
                  <source srcset={prod1ImgWebp} type="image/webp" />
                  <source srcset={prod1ImgPng} type="image/png" />
                  <img
                    src={prod1ImgPng}
                    className="rounded-sm h-auto lg:h-64"
                    alt="custom-actuators-1"
                  />
                </picture>
                {/* <img src={prod1ImgPng} className="rounded-sm h-56 sm:h-auto" alt="custom-actuators-1" /> */}
              </div>
              <div className="px-1 pt-1">
                <picture>
                  <source srcset={prod2ImgWebp} type="image/webp" />
                  <source srcset={prod2ImgPng} type="image/png" />
                  <img
                    src={prod2ImgPng}
                    className="rounded-sm h-auto lg:h-64"
                    alt="custom-actuators-2"
                  />
                </picture>
                {/* <img
                  src={prod2ImgPng}
                  className="rounded-sm h-56 sm:h-auto"
                  alt="custom-actuators-2"
                /> */}
              </div>
              <div className="px-1 pt-1">
                <picture>
                  <source srcset={prod3ImgWebp} type="image/webp" />
                  <source srcset={prod3ImgPng} type="image/png" />
                  <img
                    src={prod3ImgPng}
                    className="rounded-sm h-auto lg:h-64"
                    alt="custom-actuators-3"
                  />
                </picture>
                {/* <img
                  src={prod3ImgPng}
                  className="rounded-sm h-56 sm:h-auto"
                  alt="custom-actuators-3"
                /> */}
              </div>
            </div>
            <div class="text-lg md:text-2xl m-4 text-center">
              <h1>
                Our team of experts will help you to achieve your objectives
                within the constraints of your application.{" "}
              </h1>
            </div>
            {/* <div class="text-lg md:text-2xl px-2 pt-4">
              <h2>Breakout board for AS5047P Magnetic Encoder</h2>
            </div> */}
            {/* <div
              class="
              flex flex-row
              text-lg
              md:text-2xl
              px-2
              justify-center
              flex-wrap
            "
            >
              <div class="mx-3">
                <h3>Easy to install and use</h3>
              </div>
              <div class="mx-3">
                <h3>Both SPI and ABI Interfaces available</h3>
              </div>
              <div class="mx-3">
                <h3>
                  Resolution upto 4000 CPR (ABI Interface) and upto 14 bits (SPI
                  Interface)
                </h3>
              </div>
            </div> */}
            <div className="dont-highlight-on-touch mt-6 flex flex-col sm:flex-row justify-center items-center">
              <OutboundLink
                className="mail-btn mail-us-btn-gtag px-8 py-4 sm:mx-4 my-2 w-56 md:w-auto flex flex-row items-center justify-center text-lg md:text-xl h-auto md:h-16"
                href={"mailto:info@nawerobotics.com"}
                target="_blank"
                aria-label="Mail Us"
              >
                <div className="mr-2 mail-us-btn-gtag hidden md:inline-block">
                  <img
                    src={mailIcon}
                    className="email-icon h-6 mail-us-btn-gtag"
                    alt="mail-us"
                  />
                </div>
                <div className="inline-block mail-us-btn-gtag">
                  Drop us a mail with your requirements
                </div>
              </OutboundLink>
            </div>
          </div>
        </div>
        <div id="encoders" className="w-full">
          <div
            id="encoders"
            className="max-w-screen-xl text-white m-auto text-center pb-6 pt-1"
          >
            <div className="text-center text-xl md:text-3xl my-2 mt-4">
              Magnetic Encoders
            </div>

            <div class="text-lg md:text-2xl mb-4 text-center">
              <h1>NCoder 730</h1>
            </div>
            <div>
              <img src={encoder730Img} className="mx-auto" alt="encoder"  />
            </div>
            <div class="text-lg md:text-2xl px-2 pt-4">
              <h2>Breakout board for MA730 Magnetic Encoder</h2>
            </div>
            <div
              class="
              flex flex-row
              text-lg
              md:text-2xl
              px-2
              justify-center
              flex-wrap
            "
            >
              <div class="mx-3">
                <h3>Easy to install and use</h3>
              </div>
              <div class="mx-3">
                <h3>Both SPI and ABI Interfaces available</h3>
              </div>
              <div class="mx-3">
                <h3>
                  Resolution upto 4000 CPR (ABI Interface) and upto 14 bits (SPI
                  Interface)
                </h3>
              </div>
            </div>
            <div className="dont-highlight-on-touch mt-6 flex flex-col sm:flex-row justify-center items-center">
              <OutboundLink
                className="amazon-btn amazon-btn-gtag p-4 sm:mx-4 my-2 w-56 md:w-64 flex flex-row items-center justify-center text-lg md:text-xl h-10 md:h-16"
                href={enc730AmazonLink}
                target="_blank"
                aria-label="Buy from Amazon"
              >
                <div className="inline-block mr-2 amazon-btn-gtag">
                  <img
                    src={buyIcon}
                    className="h-6 amazon-btn-gtag"
                    alt="buy-from-amazon"
                  />
                </div>
                <div className="inline-block amazon-btn-gtag">
                  Buy from Amazon
                </div>
              </OutboundLink>

              <OutboundLink
                className="download-datasheet-btn download-datasheet-btn-gtag  p-4 sm:mx-4 my-2 w-56 md:w-64 flex flex-row items-center justify-center text-lg md:text-xl h-10 md:h-16"
                href={encoder730Datasheet}
                target="_blank"
                aria-label="Get Datasheet"
              >
                <div className="inline-block mr-2 download-datasheet-btn-gtag ">
                  <img
                    src={downloadIcon}
                    className="h-6 download-datasheet-btn-gtag "
                    alt="download"
                  />
                </div>
                <div className="inline-block download-datasheet-btn-gtag ">
                  Download Datasheet
                </div>
              </OutboundLink>
            </div>

         
            <div className="text-center text-xl md:text-3xl my-2 mt-4">
            </div>
            <div class="text-lg md:text-2xl mb-4 text-center">
              <h1>NCoder 5047</h1>
            </div>
            <div>
              <img src={encoder5047Img} className="mx-auto" alt="encoder" />
            </div>
            <div class="text-lg md:text-2xl px-2 pt-4">
              <h2>Breakout board for AS5047P Magnetic Encoder</h2>
            </div>
            <div
              class="
              flex flex-row
              text-lg
              md:text-2xl
              px-2
              justify-center
              flex-wrap
            "
            >
              <div class="mx-3">
                <h3>Easy to install and use</h3>
              </div>
              <div class="mx-3">
                <h3>Both SPI and ABI Interfaces available</h3>
              </div>
              <div class="mx-3">
                <h3>
                  Resolution upto 4000 CPR (ABI Interface) and upto 14 bits (SPI
                  Interface)
                </h3>
              </div>
            </div>
            <div className="dont-highlight-on-touch mt-6 flex flex-col sm:flex-row justify-center items-center">
              <OutboundLink
                className="amazon-btn amazon-btn-gtag p-4 sm:mx-4 my-2 w-56 md:w-64 flex flex-row items-center justify-center text-lg md:text-xl h-10 md:h-16"
                href={enc5047AmazonLink}
                target="_blank"
                aria-label="Buy from Amazon"
              >
                <div className="inline-block mr-2 amazon-btn-gtag">
                  <img
                    src={buyIcon}
                    className="h-6 amazon-btn-gtag"
                    alt="buy-from-amazon"
                  />
                </div>
                <div className="inline-block amazon-btn-gtag">
                  Buy from Amazon
                </div>
              </OutboundLink>

              <OutboundLink
                className="download-datasheet-btn download-datasheet-btn-gtag  p-4 sm:mx-4 my-2 w-56 md:w-64 flex flex-row items-center justify-center text-lg md:text-xl h-10 md:h-16"
                href={encoder5047Datasheet}
                target="_blank"
                aria-label="Get Datasheet"
              >
                <div className="inline-block mr-2 download-datasheet-btn-gtag ">
                  <img
                    src={downloadIcon}
                    className="h-6 download-datasheet-btn-gtag "
                    alt="download"
                  />
                </div>
                <div className="inline-block download-datasheet-btn-gtag ">
                  Download Datasheet
                </div>
              </OutboundLink>
            </div>


          </div>
        </div>
      </div>
    );
  }
}

export default ProductsBlock;
